import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Search from './pages/Search';
import Header from './components/Header';
import Saved from './pages/Saved';
import Event from './pages/Event';
import Purpose from './pages/Purpose';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import Footer from './components/Footer';
import NotFound from './pages/NotFound';
import { SavedProvider } from './context/SavedContext';

function App() {
  return (
    <div className="pa-app">
      <SavedProvider>
        <a className="pa-skip" href="#contenu">
          Aller au contenu
        </a>
        <Header />
        <main id="contenu" className="pa-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<Search />} />
            <Route path="/saved" element={<Saved />} />
            <Route path="/event/:id" element={<Event />} />
            <Route path="/purpose" element={<Purpose />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/confidentialite" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </SavedProvider>
    </div>
  );
}

export default App;
